import type { Message, ProductCard, RichContent } from '../types/messages';
import type { WidgetStrings } from '../i18n/types';
import { MESSAGE_TYPES } from '../constants/messageTypes';
import { formatWidgetString } from '../utils/i18n';
import { isSafeUrl } from '../utils/urlSafety';

export interface CartErrorInput {
  product: ProductCard;
  productUrl?: string | null;
  strings: WidgetStrings;
  now: Date;
  unconfirmed?: boolean;
}

/** Builds the assistant message shown when an add-to-cart could not be completed from chat. */
export function buildCartErrorMessage({
  product,
  productUrl,
  strings,
  now,
  unconfirmed = false,
}: CartErrorInput): Message {
  const safeProductUrl = productUrl && isSafeUrl(productUrl) ? productUrl : '';
  const buttons: NonNullable<RichContent['buttons']> = [];
  if (safeProductUrl) {
    buttons.push({
      label: strings.viewProduct,
      href: safeProductUrl,
      target: '_blank',
    });
  }
  buttons.push({
    label: strings.mainMenu,
    value: 'help',
  });
  return {
    id: `cart-error-${product.id || 'product'}-${now.getTime()}`,
    sender: 'ai',
    text: formatWidgetString(unconfirmed ? strings.cartAddUnconfirmed : strings.cartAddFailed, {
      item: String(product.title || '').trim() || strings.thatItem,
    }),
    timestamp: now.toISOString(),
    status: 'delivered',
    type: MESSAGE_TYPES.BUTTONS,
    richContent: {
      buttonStyle: 'pill',
      buttons,
    },
  };
}
